import { SpTooltip } from 'components/shared/Tooltip/Tooltip';
import type { IntlKey } from 'locales';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const StyledTooltipDiv = styled.div`
  max-width: 500px !important;
  min-width: 200px !important;
`;

export const LabelWithIconTooltip: FC<{ tooltip: string; label: IntlKey; defaultLabel?: string }> = ({
  tooltip,
  label,
  defaultLabel,
}) => {
  const intl = useIntl();

  return (
    <label className="text-secondary fw-medium">
      <span className="me-2">{intl.formatMessage({ id: label, defaultMessage: defaultLabel })}</span>

      <SpTooltip
        style={{ padding: 0 }}
        contents={
          <StyledTooltipDiv className="text-secondary text-start p-2 bg-primary-alt shadow">{tooltip}</StyledTooltipDiv>
        }
      >
        <i className="icon icon-sm text-secondary" id="labelWithIconTooltip">
          info_outline
        </i>
      </SpTooltip>
    </label>
  );
};

LabelWithIconTooltip.displayName = 'LabelWithIconTooltip';
